export class GenericEvent {
    name: string = null;
    data: any = null;
    constructor(name: string, data?: any) {
        this.name = name;
        this.data = data ? data : null;
    }
}

export enum enum_GenericEvents {
    'UPDATE_CONTENT' = 'updateContent',
    'FOCUS_SELECTED_DISPLAY_ON_PAGECHANGE' = 'focusSelectedDisplayOnPagechange',
    'CHANGE_SCENARIO' = 'changeScenario',
    'CHANGED_SCENARIO' = 'changedScenario',
    'OPEN_MODAL_COMPARESCENARIO' = 'openModalComparescenario',
    'OPEN_MODAL_EXPLOREDETAILS' = 'openModalExploredetails',
    'OPEN_MODAL_CONFIRM_TIMEDOUT' = 'openModalConfirmTimedout',
    'EDITABLE_HTML_SELECTED' = "editableHtmlSelected",
    'CHANGED_PAGE' = 'changedPage',
    'CLOSE_COMPARE_SCENARIO_POPUP' = 'closeCompareScenarioPopup',
    'EXIT_CALCULATOR' = 'exitThisCalculator',
    'ENABLE_MODAL_ONLY_TABBING' = 'enableModalOnlyTabbing',
    'DISABLE_MODAL_ONLY_TABBING' = 'disableModalOnlyTabbing'
}
